import React from 'react';
import { Link } from 'react-router-dom';
import logoWordmark from '../assets/logo-wordmark.png';

export default function Masthead() {
  return (
    <header className="masthead">
      <div className="masthead__inner">
        <Link to="/" className="masthead__title">
          <img src={logoWordmark} alt="OnlyFreeNews" className="masthead__logo" />
        </Link>
        <div className="masthead__right">
          <nav className="masthead__nav">
            <Link to="/our-mission" className="masthead__nav-link">
              Our Mission
            </Link>
            <Link to="/journalists" className="masthead__nav-link">
              Journalists
            </Link>
            <Link to="/publications" className="masthead__nav-link">
              Publications
            </Link>
            <Link to="/subscribe" className="masthead__nav-link">
              Subscribe
            </Link>
            <Link to="/blog" className="masthead__nav-link">
              Blog
            </Link>
          </nav>
          <form className="masthead__search" role="search" onSubmit={(e) => e.preventDefault()}>
            <input
              type="search"
              className="masthead__search-input"
              placeholder="Search"
              aria-label="Search"
            />
          </form>
        </div>
      </div>
    </header>
  );
}
